import { useLocalization } from '~/framework';
import { formatRelative, format } from 'date-fns';

export function useRelativeDate(date?: number | null): string {
   const formatter = useFormatRelativeDate();
   return formatter(date);
}

export function useFormatRelativeDate(): (date?: number | null) => string {
   const { dateFnsLocale, isMissingDateFnsLocale } = useLocalization();

   return date => {
      if (date === null || date === undefined) return '';

      if (isMissingDateFnsLocale) {
         return format(date * 1000, 'MM/dd/yyyy');
      }

      return formatRelative(date * 1000, Date.now(), {
         locale: dateFnsLocale,
      });
   };
}

export function useFormatAbsoluteDateTime(): (date?: number | null) => string {
   const { dateFnsLocale } = useLocalization();

   return date => {
      if (date === null || date === undefined) return '';

      return format(date * 1000, 'Pp', {
         locale: dateFnsLocale,
      });
   };
}

export function useFormatAbsoluteDate(): (date?: number | null) => string {
   const { dateFnsLocale } = useLocalization();

   return date => {
      if (date === null || date === undefined) return '';

      return format(date * 1000, 'P', {
         locale: dateFnsLocale,
      });
   };
}
